export const state = () => ({
	events: {},
});
export const mutations = {
	setEvents(state: any, payload: any) {
		state.events = payload;
	},
};
export const getters = {
	getEvents: (state: any) => state.events,
};
export const actions = {
	async fetchEvents(state: any, payload: any) {
		let url = payload?.url || '/api/company/' + state.rootState.auth.user.company.uuid + '/events';

		return new Promise((resolve, reject) => {
			this.$axios
				.get(url)
				.then((res) => {
					state.commit('setEvents', res.data);
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
};
